import styled from 'styled-components';
import { PageWrap } from '@minerva-analytics/pantheon';

const LeaderboardContainer = styled(PageWrap)`
  text-align: center;
`;

const LeaderboardTitle = styled.h3`
  margin-bottom: 20px;
`;

export {
  LeaderboardContainer,
  LeaderboardTitle,
};
